var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"guide"},[_c('div',{staticStyle:{"width":"100%"}},[_c('description'),_c('setup'),_c('login'),_c('usage'),_c('sip-support'),_c('push-notification')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }